import { useContext } from 'react';
import { LocalizationContext } from './context';
export function useSuppressHydrationWarningSetting() {
    var _a;
    var context = useContext(LocalizationContext);
    return (_a = context.suppressLocaleHydrationWarnings) !== null && _a !== void 0 ? _a : false;
}
//# sourceMappingURL=useSuppressHydrationWarningSetting.js.map